import React, { useEffect, useLayoutEffect, useState } from 'react'
import { StoreProvider } from './StoreProvider'
import { Spin } from 'antd'
import { useStoreContext } from './store.context'
import { useSearchParams } from '@/hooks/useSearchParams'
import { useAppContext } from '../app'
const WrappedStoreComponent = React.memo<React.PropsWithChildren<object>>(({ children }) => {
  const { loading } = useStoreContext()

  return <Spin spinning={loading}>{children}</Spin>
})

/**
 *  需要选择具体店铺的Hoc组件
 *
 * @param BaseComponent
 * @param storeIdKey
 * @returns
 */
export function withSelectedStore<
  T extends object,
  P extends React.ComponentProps<React.ComponentType<T & Record<string, unknown>>>,
  R extends unknown = any,
>(BaseComponent: React.ComponentType<T>, useQueryStoreId = true) {
  const WrappedComponent: React.ForwardRefRenderFunction<R, P> = (props, ref) => {
    // 添加 loading 用于 Modal 弹窗页面，等待设置 storeId 成功后再打开
    const [loading, setLoading] = useState(true)
    const { setStoreId } = useAppContext()
    const paramStoreId = useSearchParams('storeId', 0, Number) || 0

    useLayoutEffect(() => {
      setTimeout(() => {
        setLoading(false)
      }, 0)
    }, [])
    useEffect(() => {
      if (useQueryStoreId && paramStoreId) {
        setStoreId(paramStoreId)
        return () => {
          setStoreId(0)
        }
      }
    }, [paramStoreId, setStoreId])

    if (loading) {
      return null
    }

    return (
      <StoreProvider>
        <WrappedStoreComponent>
          <BaseComponent ref={ref} {...props} />
        </WrappedStoreComponent>
      </StoreProvider>
    )
  }

  WrappedComponent.displayName = `withSelectedStore(${
    BaseComponent.displayName || BaseComponent.name || 'Unknown'
  })`

  return React.memo(React.forwardRef<R, P>(WrappedComponent))
}
